import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

  constructor(
    private http: Http,
  ) { }

  createAuthorizationHeader(header: Headers) {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    let authToken = '';
    if (user && user.isLogin == true) {
      authToken = user.accessToken;
      header.append('accessToken', authToken);
    }
  }

  get(url) {
    const headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(url, {
      headers
    });
  }

  post(url, data, contentType: string = '') {
    const headers = new Headers();
    this.createAuthorizationHeader(headers);
    if (contentType) {
      headers.append('Content-Type', contentType);
    }
    return this.http.post(url, data, {
      headers
    });
  }


  serheader(header: Headers) {
    header.append('Content-Type', 'application/json; charset=utf-8');
    header.append('Content-Length', '135');
  }

  sociallogin(url) {
    const headers = new Headers();
    this.serheader(headers);
    return this.http.get(url, {
      headers
    });
  }

  setlogutheader(header: Headers) {
    const userData = JSON.parse(localStorage.getItem('userDetails'));
    // header.append('Content-Type', 'application/json; charset=utf-8');
    // header.append('Content-Length', '135');

    // header.append('authorization','OAuth');
    // header.append('oauth_token',userData.accessToken);

    // header.append('authorization',"OAuth");
    // header.append('oauth_consumer_key',"CLIENT_KEY");
    // header.append('oauth_nonce', "AUTO_GENERATED_NONCE");
    // header.append('oauth_signature',"AUTO_GENERATED_SIGNATURE");
    // header.append('oauth_signature_method', "HMAC");
    // header.append('oauth_timestamp',"AUTO_GENERATED_TIMESTAMP");
    // header.append('oauth_token', "ACCESS_TOKEN");
    // header.append('oauth_version',"1.0");

    // header.append("Access-Control-Allow-Origin", "*")
    // header.append("Access-Control-Allow-Methods", "DELETE, POST, GET, OPTIONS")
    // header.append("Access-Control-Allow-Headers", "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With")

    header.append('Access-Control-Allow-Origin', '*');
    header.append('Access-Control-Allow-Methods', 'DELETE, POST, GET, OPTIONS');
    header.append('Access-Control-Allow-Credentials', 'true');

  }

  sociallogout(url, data) {
    const headers = new Headers();
    this.setlogutheader(headers);
    return this.http.post(url, data, {
      headers
    });
  }
}
